import styles from "./ConsultationList.module.css";

const ConsultationList = ({ consultationData, onEntryClick }) => {
  const formatDateString = (dateString) => {
    const date = new Date(dateString);
    return date.toISOString().split("T")[0];
  };

  return (
    <div>
      <div className={styles.userInfoBox}>
        {/* <div className={styles.avatar}></div> */}
        <div className={styles.userInfoDetails}>
          <p className={styles.userName}>에이콘</p>
          <p className={styles.userEmail}>acornpub@acornpub.co.kr</p>
        </div>
        <div className={styles.consultationCountBox}>
          <p>내 출판상담</p>
          <span>{consultationData.length}</span>
        </div>
      </div>

      <div className={styles.sectionHeader}>
        <h2 className={styles.sectionTitle}>모의 견적 내역</h2>
        {/* <p className={styles.sectionSubtitle}>최근 1개월 이내 내역</p> */}
      </div>

      <table className={styles.consultationTable}>
        <thead>
          <tr>
            <th>제목</th>
            <th>작성일</th>
          </tr>
        </thead>
        <tbody>
          {consultationData.map((entry) => (
            <tr key={entry.selfPublishingId} onClick={() => onEntryClick(entry.selfPublishingId)}>
              <td data-label="제목" className={styles.tableTitle}>
                [ 출판 견적서 ] {entry.title}
              </td>
              <td data-label="작성일">{formatDateString(entry.dateCreated)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ConsultationList;
